import { Routes, Route, Router, hashIntegration, useParams  } from "@solidjs/router"
import { Component, ErrorBoundary } from "solid-js";
import { fetchGet } from "./library/common";
import { IndexPage } from "./pages";
import { SearchPage } from "./pages/search";

export const cache: Record<string, any> = {};

export const App : Component = (props) => {
    const loadSearchResources = async ({ navigate }: any) => {
        try {
            const res = await fetch("/ArtistPortrait/GetSearchResourcesJson");
            const json = await res.json();
            if (!json.Success) {
                navigate("/not-found");
                return;
            }
            return {
                resources: json.Data
            };
        }
        catch (ex) {
            console.log({ ex });
            navigate("/error", { state: { ex }});
        }
    };
    const loadIndex = async ({ params, navigate }: any) => {
        try {
            const id = params.id as number;
            const res = await fetchGet("/ArtistPortrait/FindJson", { id });
            const json = await res.json();
            if (!json.Success) {
                navigate("/not-found");
                return;
            }
            return {
                artistPortrait: json.Data
            };
        }
        catch (ex) {
            console.log({ ex });
            navigate("/error", { state: { ex }});
        }
    };
    return (
        <div style="position: relative;">
            <Router source={hashIntegration()}>
                <ErrorBoundary fallback={err => <div class="blank-page">{err.toString()}</div>}>
                    <Routes>
                        <Route path="/index/:id" component={IndexPage} data={loadIndex} />
                        <Route path={["/search","/"]} component={SearchPage} data={loadSearchResources} />
                        <Route path={"/not-found"} component={() => {
                            return (
                                <div class="blank-page">
                                    Sorry, that page was not found
                                </div>
                            )
                        }}></Route>
                        <Route path={"/error"} component={() => {
                            const params = useParams();
                            return (
                                <div class="blank-page">
                                    <h2>Sorry, there has been an error</h2>
                                    <div>{params.ex?.toString()}</div>
                                </div>
                            )
                        }}></Route>
                    </Routes>
                </ErrorBoundary>
            </Router>
        </div>
    );
}
